module.exports = __webpack_public_path__ + "media/images/choose/dashboard-b79ed7d8dc3277c96bf4c612927c17b6.png";